export default "__VITE_ASSET__V5q5YYaH__"